export type SessionEntryVariant = "header" | "hero";

export type SessionResponse = {
  authenticated?: boolean;
  user?: {
    name?: string;
    username?: string;
    email?: string;
  };
};

export type CachedAuthenticatedSession = {
  authenticated: true;
  userName: string;
  expiresAt: number;
};

export const SESSION_ENTRY_STORAGE_KEY_PREFIX = "platform-website:session:";
export const SESSION_ENTRY_CACHE_TTL_MS = 5 * 60 * 1000;

export function getSessionEntryStorageKey(sessionApiUrl: string): string {
  return `${SESSION_ENTRY_STORAGE_KEY_PREFIX}${sessionApiUrl}`;
}

export function resolveUserName(user: SessionResponse["user"] | undefined): string {
  const candidate = user?.name?.trim() || user?.username?.trim() || user?.email?.trim();
  return candidate || "用户";
}
